/*
* routes.js
*
* Description: Holds common/global Routes for Module::'Hotels'.
*
* This file is part of: "http://apps.sundair.com/", "SunCrew - Hotels"
* Copyright 2018,2019,2020,2021 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Christian Arp <christian.arp@sundair.com>
* @author Learek <michael.broeker@sundair.com>
* @author Phillip Alsleben <phillip.alsleben@sundair.com>
*
*/
import Vue from 'vue';
import Router from 'vue-router';
import { store } from './stores/store';
import { CONF_NEEDED_PERMISSION } from '../src/config';

Vue.use(Router);


export default new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        // >>> ----------------------------------------------------------------- '/'
        {
            path: '/',
            component: () => import('@/views/dashboard/Index'),
            children: [
                {
                    name: 'Dashboard',
                    path: '',
                    component: () => import('@/views/dashboard/Dashboard'),
                    beforeEnter(to, from, next) {
                        if (store.state.shared.idUser) {
                            next();
                        } else {
                            next('/pages/login');
                        }
                    }
                }
            ]
        },
        // >>> ----------------------------------------------------------------- '/vacations'
        {
            path: '/vacations',
            component: () => import('@/views/vacations/Index'),
            children: [
                {
                    name: 'Vacations',
                    path: 'Vacations',
                    component: () => import('@/views/vacations/vacations/Home'),
                    beforeEnter(to, from, next) {

                        store.state.shared.shared_Path = to.name;

                        if (store.state.shared.idUser) {
                            // if (store.state.shared.shared_usersGrantsList.includes(String(CONF_NEEDED_PERMISSION))) {
                            //     next();
                            // } else {
                            next();
                            // }
                        } else {
                            next('/pages/login');
                        }
                    }
                },
                {
                    name: 'Status Overview',
                    path: 'statusoverview',
                    component: () => import('@/views/vacations/statusoverview/Home'),
                    beforeEnter(to, from, next) {

                        store.state.shared.shared_Path = to.name;

                        if (store.state.shared.idUser) {
                            // if (store.state.shared.shared_usersGrantsList.includes(String(CONF_NEEDED_PERMISSION))) {
                            //     next();
                            // } else {
                            next();
                            // }
                        } else {
                            next('/pages/login');
                        }
                    }
                },

            ]
        },
        // >>> ----------------------------------------------------------------- '/pages'
        {
            path: '/pages',
            component: () => import('@/views/pages/Index'),
            children: [
                {
                    name: 'Lock',
                    path: 'lock',
                    component: () => import('@/views/pages/Lock')
                },
                {
                    name: 'Login',
                    path: 'login',
                    component: () => import('@/views/pages/Login')
                }
            ]
        },
        // >>> ----------------------------------------------------------------- '404'
        {
            path: '*',
            component: () => import('@/views/pages/Index'),
            children: [
                {
                    name: '404 Error',
                    path: '',
                    component: () => import('@/views/pages/Error')
                }
            ]
        }
    ]
});
